import axios from 'axios';

// Doğrudan backend URL kullan
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_API_URL || 'http://localhost:5000/api',
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - token & security headers
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    const secPass = localStorage.getItem('mashow_sec_pass');
    if (secPass) {
      config.headers['x-security-pass'] = secPass;
    }
    config.headers['x-mashow-security-token'] = 'mashow-secure-client-v1';
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - hata yönetimi & firewall koruması
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // 403 Firewall Security Challenge
    if (error.response?.status === 403 && error.response?.data?.securityChallenge) {
      if (window.location.pathname !== '/security-challenge') {
        window.location.href = '/security-challenge';
      }
    }

    // 401 hatası - token geçersiz veya yok
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('auth-storage');
      
      const currentPath = window.location.pathname;
      const publicPaths = ['/login', '/register', '/', '/products'];
      const isPublicPath = publicPaths.includes(currentPath) || currentPath.startsWith('/products/');
      
      if (!isPublicPath) {
        window.location.href = '/login';
      }
    }
    
    const message = error.response?.data?.message || 'Bir hata oluştu';
    return Promise.reject({ message, ...error.response?.data });
  }
);

export default axiosInstance;

